const SENTENCES = /[^.!?]+[.!?]+/g;

/** A paragraph's sentences, trimmed, in order. */
export function splitSentences(paragraph: string): string[] {
  return (paragraph.match(SENTENCES) ?? []).map((sentence) => sentence.trim());
}

/**
 * The paragraph with its sentences moved `shift` places round (the first `shift` go to the
 * end). Deterministic, keeps every word, and makes a reused paragraph read differently.
 */
export function rotateSentences(paragraph: string, shift: number): string {
  const sentences = splitSentences(paragraph);
  if (sentences.length < 2) {
    return paragraph;
  }
  const by = shift % sentences.length;
  return [...sentences.slice(by), ...sentences.slice(0, by)].join(" ");
}

/**
 * `count` paragraphs from the corpus, in order.
 *
 * With `startClassic` the first is the corpus's opening paragraph ("Lorem ipsum dolor sit
 * amet…"); without it the text starts one paragraph later. When more paragraphs are asked
 * for than the corpus holds, each pass through the corpus rotates the sentences by one
 * more place, so a reused paragraph is never word-for-word identical to an earlier one.
 */
export function loremParagraphs(
  corpus: readonly string[],
  count: number,
  startClassic: boolean
): string[] {
  const offset = startClassic ? 0 : 1;
  const result: string[] = [];
  for (let i = 0; i < count; i += 1) {
    const position = offset + i;
    const base = corpus[position % corpus.length] ?? "";
    const pass = Math.floor(position / corpus.length);
    result.push(pass === 0 ? base : rotateSentences(base, pass));
  }
  return result;
}
